var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cui-view class=\"block-component\"\u003E\u003C\u002Fui-view\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ./src/application/scene/authorized/authorized.tpl.pug
// module id = x28t
// module chunks = 0